/** Accent + chip colors per subject tag (slug or display name). */
export const SUBJECT_TAG_COLORS = {
  "social-justice": { accent: "#E07A4F", bg: "#FFF0E8", text: "#B45309" },
  economy: { accent: "#2F9FD6", bg: "#E8F7FD", text: "#0F6F9A" },
  "sci-tech": { accent: "#7C5CFC", bg: "#F0EBFF", text: "#5B3FD4" },
  constitution: { accent: "#D97706", bg: "#FFF7E8", text: "#B45309" },
  agriculture: { accent: "#16A34A", bg: "#ECFDF3", text: "#15803D" },
  "indian-society": { accent: "#DB2777", bg: "#FDF2F8", text: "#BE185D" },
  polity: { accent: "#2563EB", bg: "#EFF6FF", text: "#1D4ED8" },
  "ethics-integrity": { accent: "#9333EA", bg: "#F5F3FF", text: "#7E22CE" },
  environment: { accent: "#059669", bg: "#ECFDF5", text: "#047857" },
  history: { accent: "#B45309", bg: "#FFFBEB", text: "#92400E" },
  governance: { accent: "#4F46E5", bg: "#EEF2FF", text: "#4338CA" },
  goverance: { accent: "#4F46E5", bg: "#EEF2FF", text: "#4338CA" },
  maths: { accent: "#0891B2", bg: "#ECFEFF", text: "#0E7490" },
  security: { accent: "#DC2626", bg: "#FEF2F2", text: "#B91C1C" },
  geography: { accent: "#0D9488", bg: "#F0FDFA", text: "#0F766E" },
  "intl-relations": { accent: "#EA580C", bg: "#FFF7ED", text: "#C2410C" },
  "international-relations": { accent: "#EA580C", bg: "#FFF7ED", text: "#C2410C" },
  "disaster-management": { accent: "#CA8A04", bg: "#FEFCE8", text: "#A16207" },
  "environment-disaster-management": { accent: "#059669", bg: "#ECFDF5", text: "#047857" },
  "society-social-justice": { accent: "#E07A4F", bg: "#FFF0E8", text: "#B45309" },
  "science-tech": { accent: "#7C5CFC", bg: "#F0EBFF", text: "#5B3FD4" },
  "internal-security": { accent: "#DC2626", bg: "#FEF2F2", text: "#B91C1C" },
  "post-independence": { accent: "#B45309", bg: "#FFFBEB", text: "#92400E" },
  "world-history": { accent: "#B45309", bg: "#FFFBEB", text: "#92400E" },
  "modern-history": { accent: "#B45309", bg: "#FFFBEB", text: "#92400E" },
  amac: { accent: "#D97706", bg: "#FFF7E8", text: "#B45309" },
  ethics: { accent: "#9333EA", bg: "#F5F3FF", text: "#7E22CE" },
  "general-upsc-preparation-strategy": {
    accent: "#64748B",
    bg: "#F1F5F9",
    text: "#475569",
  },
  general: { accent: "#64748B", bg: "#F1F5F9", text: "#475569" },
  "current affairs": { accent: "#8B5CF6", bg: "#F5F3FF", text: "#6D28D9" },
};

/** Fallback palette for custom user tags. */
export const CUSTOM_TAG_COLOR_PALETTE = [
  { accent: "#2F9FD6", bg: "#E8F7FD", text: "#0F6F9A" },
  { accent: "#E07A4F", bg: "#FFF0E8", text: "#B45309" },
  { accent: "#16A34A", bg: "#ECFDF3", text: "#15803D" },
  { accent: "#9333EA", bg: "#F5F3FF", text: "#7E22CE" },
  { accent: "#DC2626", bg: "#FEF2F2", text: "#B91C1C" },
  { accent: "#0D9488", bg: "#F0FDFA", text: "#0F766E" },
];
